function OnConfig($stateProvider, $locationProvider, $urlRouterProvider, $compileProvider) {
    'ngInject';

    if (process.env.NODE_ENV === 'production') {
        $compileProvider.debugInfoEnabled(false);
    }

    $locationProvider.html5Mode({
        enabled: true,
        requireBase: false
    });

    $stateProvider
        .state('login', {
            url: '/login?errorType',
            controller: 'LoginCtrl as login',
            templateUrl: 'login.html',
            title: 'Login',
            resolve: {
                // Redirect to the user's dashboard page if user is logged in.
                auth: function($auth, $state) {
                    $auth.validateUser()
                        .then(function() {
                            if ($auth.user) {
                                if ($auth.user.role == 'admin'){
                                    return $state.go('user.mainDashboard', { inherit: false });
                                }else{
                                    return $state.go('client.clientDashboard.default', { inherit: false });
                                }
                            }
                        });
                }
            }
        })
        //Start of admin routing
        .state('user', {
            url: '',
            controller: 'UserCtrl as user',
            templateUrl: 'layouts/header.html',
            abstract: true,
            resolve: {
                auth: function($auth, $state) {
                    $auth.validateUser()
                        .then(function() {
                            if ($auth.user) {
                                if($auth.user.role == 'admin'){
                                    return true;
                                }else{
                                    return $state.go('client.clientDashboard.default', { inherit: false });
                                }
                            }
                        })
                        .catch(function() {
                            return $state.go('login', { inherit: false });
                        });
                }
            }
        })
        .state('user.already_connected', {
            url: '/already_connected',
            templateUrl: 'layouts/already_conn.html',
        })
        .state('user.connection', {
            url: '/connection',
            templateUrl: 'settings_ui/connections/connection-view.html',
            abstract: true,
            breadCrumb: 'Connection',
            redirectTo: 'user.connection.default'
            })
        .state('user.connection.default',{
            url: '',
            controller: 'ConnectionCtrl as connection',
            templateUrl: 'settings_ui/connections/connections.html',
            title: 'Connection',
            // breadCrumb: 'Connection'
        })
        .state('user.connection.amazon-conn', {
            url: '/amazon-connection/:editId',
            controller: 'ConnectionCtrl as connection',
            templateUrl: 'settings_ui/connections/amazon-connection.html',
            title: 'Amazon Connection',
            breadCrumb: 'Amazon Connection'
        })
        .state('user.notification', {
            url: '/notification?pageNumber&size',
            controller: 'NotificationCtrl as notification',
            templateUrl: 'layouts/notification.html',
            title: 'Notification',
            breadCrumb: 'Notification'
        })
        .state('user.admin', {
            url: '/admin',
            templateUrl: 'layouts/admin.html',
            abstract: true,
            breadCrumb: 'Admin'
        })
        .state('user.admin.users', {
            url: '/users?pageNumber&size&name&email&company&sortBy',
            controller: 'AdminCtrl as admin',
            templateUrl: 'admin/users.html',
            resolve: {
                auth: function($auth, $state) {
                    $auth.validateUser()
                        .then(function() {
                            if ($auth.user.role == 'admin' || $auth.user.role == 'accountant') {
                                return true;
                            } else {
                                return $state.go('user.mainDashboard', { inherit: false });
                            }
                        })
                        .catch(function() {
                            return $state.go('login', { inherit: false });
                        });
                }
            },
            breadCrumb: 'User'
        })
        .state('user.admin.system_setting', {
          url: '/system_settings',
          controller: 'SystemSettingCtrl as systemSetting',
          templateUrl: 'admin/system_setting.html',
          resolve: {
              auth: function($auth, $state) {
                  $auth.validateUser()
                      .then(function() {
                          if ($auth.user.role == 'admin' ) {
                              return true;
                          } else {
                              return $state.go('user.organization.dashboard.bulk', { inherit: false });
                          }
                      })
                      .catch(function() {
                          return $state.go('login', { inherit: false });
                      });
              }
          },
          breadCrumb: 'System Setting'
      })
        .state('user.admin.resolutionOptions', {
            url: '/resolution-options?pageNumber&size&name&sortBy',
            templateUrl: 'admin/resolution-options.html',
            controller: 'ResolutionCtrl as resolution',
            breadCrumb: 'Resolution Options'
        })
        .state('user.admin.reviewRules', {
            url: '/review-rules',
            templateUrl: 'admin/review-rules.html',
            controller: 'ReviewRulesCtrl as reviewRules',
            breadCrumb: 'Review Rules'
        })
        .state('user.admin.checklists', {
            url: '/checklists-template',
            template: '<div ui-view> </div>',
            breadCrumb: 'Checklist Templates',
            abstract: true,
            redirectTo: 'user.admin.checklists.default'
        })
        .state('user.admin.checklists.default', {
            url: '',
            templateUrl: 'admin/checklists.html',
            controller: 'ChecklistCtrl as checklist',
        })
        .state('user.admin.checklists.taskNew', {
            url: '/tasks/list{id}/task{taskId}',
            templateUrl: 'admin/task-new.html',
            controller: 'ChecklistCtrl as checklist',
            breadCrumb: 'Add or Edit Task',
        })
        .state('user.mainDashboard', {
            url: '/?pageNumber&size&date&orgName&reviewStatus&sortBy',
            templateUrl: 'dashboard/main-dashboard.html',
            controller: 'MainDashboardCtrl as mainDashboard',
            breadCrumb: 'Dashboard'
        })
        .state('user.organization', {
            url: '/organization{orgId}',
            template: '<div ui-view> </div>',
            abstract: true,
            resolve: {
                organizations: function($auth, $stateParams, UserService, $state, $rootScope, toaster, CommonService) {
                    //To show the organization name on right top corner
                    $rootScope.organizationNameView = true;
                    UserService.organizations($stateParams.orgId, function(data) {
                        if(data && data.data && data.data.system_setting){
                          $rootScope.systemSetting = data.data.system_setting;
                        }
                        if (data && data.data && data.data.organizations.length > 0) {
                            var index = (data.data.organizations.map(function(d) {
                                return d.organization.id;
                            })).indexOf(parseInt($stateParams.orgId));
                            if (index == -1 && !data.data.default_organization) {
                                return $state.go($state.current.name, { orgId: data.data.organizations[0].organization.id }, { inherit: false });
                            } else {
                                $rootScope.userOrganizations = UserService.getOrganizationArray(data.data);
                                $rootScope.currentOrg = $stateParams.orgId;
                                $rootScope.currentOrgObj = data.data.default_organization ? data.data.default_organization : data.data.organizations.find(d => d.organization.id == $rootScope.currentOrg).organization;
                            }
                        } else if (data && data.data && data.data.errors && data.data.errors.length > 0) {
                            toaster.pop('error', CommonService.throwError(data));
                            return $state.go('user.connection.default', { inherit: false });
                        } else {
                            toaster.pop('info', 'You do not have any organizations. Please connect to Xero and select organization.');
                            return $state.go('user.connection.default', { inherit: false });
                        }
                    });
                }
            }
        })
        .state('user.organization.dashboard', {
            url: '',
            templateUrl: 'layouts/dashboard.html',
            abstract: true,
            breadCrumb: 'Tools',
            redirectTo: 'user.organization.dashboard.bulk'
        })
        .state('user.organization.dashboard.default', {
            url: '/',
            templateUrl: 'tools/bulk_costs/bulk.html',
            title: 'Bulk Cost',
            breadCumb: 'Bulk Cost',

        })
        .state('user.organization.dashboard.bulk', {
            url: '/bulk?pageNumber&size&journalId&accountId&fromdate&todate&sortBy',
            templateUrl: 'tools/bulk_costs/bulk.html',
            controller: 'BulkCostCtrl as bulkCost',
            title: 'Bulk Cost',
            breadCrumb: 'Bulk Cost'
        })
        .state('user.organization.dashboard.review', {
            url: '/review?sortBy?date',
            templateUrl: 'tools/review.html',
            controller: 'ReviewCtrl as review',
            title: 'Review',
            breadCrumb: 'Review'
        })
        .state('user.organization.dashboard.bulk-detail', {
            url: '/bulk-detail/:bulkCostid',
            templateUrl: 'tools/bulk_costs/bulk-detail.html',
            controller: 'BulkCostCtrl as bulkCost',
            title: 'Bulk Cost',
            breadCrumb: 'Bulk Cost'
        })
        .state('user.organization.dashboard.amazon', {
            url: '/amazon',
            template: '<div ui-view></div>',
            controller: 'AmazonCtrl as amazon',
            title: 'Amazon COGS',
            abstract: true,
            params: {
                orgId: null
            },
            breadCrumb: 'Amazon COGS',
            redirectTo: 'user.organization.dashboard.amazon.amazon-cogs'
        })
        .state('user.organization.dashboard.amazon.amazon-cogs', {
            url: '?pageNumber&size&journalId&fromdate&todate&sortBy',
            controller: 'AmazonCtrl as amazon',
            templateUrl: 'tools/amazon/amazon.html',
            title: 'Amazon COGS',
            params: {
                //orgId: null
            }
        })
        .state('user.organization.dashboard.amazon.newJournal', {
            url: '/inventory-reconcillation-report',
            templateUrl: 'tools/amazon/new-journal.html',
            title: 'New Journal',
            params: {
                orgId: null
            },
            breadCrumb: 'Add'
        })
        .state('user.organization.dashboard.amazon.detail', {
            url: '/amazon-detail/:journalid',
            templateUrl: 'tools/amazon/amazon-detail.html',
            title: 'Amazon Detail',
            controller: 'AmazonCtrl as amazon',
            params: {
                orgId: null,
                journalid: null
            },
            breadCrumb: 'Detail'
        })
        .state('user.organization.dashboard.shopify', {
            url: '/shopify',
            template: '<div ui-view></div>',
            controller: 'ShopifyCtrl as shopify',
            title: 'Shopify',
            abstract: true,
            params: {
                orgId: null
            },
            breadCrumb: 'Shopify Payouts',
            redirectTo: 'user.organization.dashboard.shopify.invoice'
        })
        .state('user.organization.dashboard.shopify.invoice', {
            url: '?pageNumber&size&invoiceId&fromdate&todate&sortBy',
            templateUrl: 'tools/shopify/shopify.html',
            controller: 'ShopifyCtrl as shopify',
            title: 'Shopify Payouts',
            params: {
                //orgId: null
            }
        })
        .state('user.organization.dashboard.shopify.newInvoice', {
            url: '/payout-report',
            templateUrl: 'tools/shopify/new-invoice.html',
            title: 'New Invoice',
            breadCrumb: 'Add'
        })
        .state('user.organization.dashboard.shopify.detail', {
            url: '/invoice-detail/:invoiceid',
            controller: 'ShopifyCtrl as shopify',
            templateUrl: 'tools/shopify/invoice-detail.html',
            title: 'Invoice Detail',
            params: {
                orgId: null
            },
            breadCrumb: 'Detail'
        })
        .state('user.organization.dashboard.reports', {
            url: '/reports',
            template: '<div ui-view></div>',
            controller: 'ReportsCtrl as reports',
            title: 'Reports',
            abstract: true,
            params: {
                orgId: null
            },
            breadCrumb: 'Reports',
            redirectTo: 'user.organization.dashboard.reports.list'
        })
        .state('user.organization.dashboard.reports.list', {
            url: '?pageNumber&size&fromdate&todate&sortBy',
            templateUrl: 'tools/reports_list.html',
            controller: 'ReportsCtrl as reports',
            title: 'Reports',
            params: {
                //orgId: null
            }
        })
        .state('user.organization.dashboard.reports.exportPAndL', {
            url: '/p-and-l',
            templateUrl: 'tools/shopify/new-invoice.html',
            title: 'Profit & Loss',
            breadCrumb: 'P&L'
        })
        .state('user.organization.dashboard.amazonPayout', {
            url: '/amazon-payout',
            template: '<div ui-view></div>',
            controller: 'AmazonPayoutCtrl as amazonPayout',
            title: 'Amazon Payouts',
            abstract: true,
            params: {
                orgId: null
            },
            breadCrumb: 'Amazon Payouts',
            redirectTo: 'user.organization.dashboard.amazonPayout.invoices'
        })

        .state('user.organization.dashboard.amazonPayout.invoices', {
            url: '?pageNumber&size&invoiceId&fromdate&todate&marketplace&sortBy',
            templateUrl: 'tools/amazon_payouts/amazon-payout.html',
            controller: 'AmazonPayoutCtrl as amazonPayout',
            title: 'Amazon Payouts',
            params: {
                //orgId: null
            }
        })
        .state('user.organization.dashboard.amazonPayout.details', {
            url: '/details/:invoiceId?pageNumber&size&sortBy&transactionType&amountType&amountDescription&marketplaceName',
            templateUrl: 'tools/amazon_payouts/amazon-payout-details.html',
            controller: 'AmazonPayoutDetailCtrl as amazonPayoutDetail',
            title: 'Amazon Payout Details',
            params: {
                //orgId: null
            }
        })
        .state('user.organization.dashboard.amazonPayout.newInvoice', {
            url: '/amazon-payout-report',
            templateUrl: 'tools/amazon_payouts/amazon-payout-new-invoice.html',
            title: 'New Invoice',
            breadCrumb: 'Add'
        })
        // DD+7 Deferred Transactions
        .state('user.organization.dashboard.dd7', {
            url: '/dd7',
            template: '<div ui-view></div>',
            controller: 'Dd7Ctrl as dd7',
            title: 'DD+7 Deferred Transactions',
            abstract: true,
            breadCrumb: 'DD+7',
            redirectTo: 'user.organization.dashboard.dd7.list'
        })
        .state('user.organization.dashboard.dd7.list', {
            url: '?pageNumber&size&month&status&sortBy',
            templateUrl: 'tools/dd7/dd7-dashboard.html',
            controller: 'Dd7Ctrl as dd7',
            title: 'DD+7 Deferred Transactions',
            params: {}
        })
        .state('user.organization.dashboard.dd7.detail', {
            url: '/detail/:runId',
            templateUrl: 'tools/dd7/dd7-detail.html',
            controller: 'Dd7DetailCtrl as dd7Detail',
            title: 'DD+7 Accrual Detail',
            breadCrumb: 'Detail'
        })
        .state('user.organization.dashboard.dd7.upload', {
            url: '/upload',
            templateUrl: 'tools/dd7/dd7-upload.html',
            controller: 'Dd7UploadCtrl as dd7Upload',
            title: 'Upload Deferred Report',
            breadCrumb: 'Upload'
        })
        .state('user.organization.dashboard.dd7.settings', {
            url: '/settings',
            templateUrl: 'tools/dd7/dd7-settings.html',
            controller: 'Dd7SettingsCtrl as dd7Settings',
            title: 'DD+7 Settings',
            breadCrumb: 'Settings'
        })
        .state('user.organization.dashboard.transactionReports', {
            url: '/transaction-reports',
            templateUrl: 'tools/transaction_reports/dashboard.html',
            controller: 'TransactionReportsCtrl as txn',
            title: 'Transaction Reports',
            breadCrumb: 'Transaction Reports'
        })
        .state('user.organization.settingView', {
            url: '/setting-view',
            abstract: true,
            templateUrl: 'layouts/setting-view.html',
            breadCrumb: 'Settings',
            redirectTo: 'user.organization.settingView.mapping.bulk-mapping'
        })

    .state('user.organization.settingView.mapping', {
        url: '/mapping',
        controller: 'MappingCtrl as mapping',
        templateUrl: 'common/mapping.html',
        breadCrumb: 'Mapping',
        redirectTo: 'user.organization.settingView.mapping.bulk-mapping'
    })

    .state('user.organization.settingView.mapping.bulk-mapping', {
            url: '/bulk-cost?pageNumber&size&account&sortBy',
            controller: 'BulkCostMappingCtrl as bulkcostmapping',
            templateUrl: 'settings_ui/mapping/bulk_costs/bulk-mapping.html',
            title: 'Bulk Cost Mapping',
            breadCrumb: 'Bulk Cost'
        })
        .state('user.organization.settingView.mapping.bulkNewMapping', {
            url: '/bulk-new-mapping/:bulkmappingid',
            controller: 'BulkCostMappingCtrl as bulkcostmapping',
            templateUrl: 'settings_ui/mapping/bulk_costs/bulk-new-mapping.html',
            params: {
                orgId: null,
                editmapping: null
            },
            title: 'Bulk Cost New Mapping',
            breadCrumb: 'Bulk Cost'
        })
        .state('user.organization.settingView.mapping.bulkCostMapping', {
            url: '/bulk-cost',
            templateUrl: 'settings_ui/bulk-cost-mapping.html',
            title: 'Bulk Cost Mapping',
            breadCrumb: 'Bulk Cost'
        })
        .state('user.organization.settingView.mapping.amazonNewMapping', {
            url: '/amazon-new-mapping',
            controller: 'AmazonMappingCtrl as amazonmapping',
            templateUrl: 'settings_ui/mapping/amazon/amazon-new-mapping.html',
            params: {
                orgId: null,
                editMapping: null
            },
            title: 'Amazon COGS New Mapping',
            breadCrumb: 'Amazon COGS'
        })
        .state('user.organization.settingView.mapping.amazon-mapping', {
            url: '/amazon',
            templateUrl: 'settings_ui/mapping/amazon/amazon-mapping.html',
            controller: 'AmazonMappingCtrl as amazonmapping',
            params: {
                orgId: null,
                mapping: null
            },
            title: 'Amazon COGS Mapping',
            breadCrumb: 'Amazon COGS'
        })
        .state('user.organization.settingView.mapping.shopifyNewMapping', {
            url: '/shopify-new-mapping',
            templateUrl: 'settings_ui/mapping/shopify/shopify-new-mapping.html',
            controller: 'ShopifyMappingCtrl as shopifymapping',
            params: {
                orgId: null,
                editMapping: null,
                shopifyAccounts: null
            },
            title: 'Shopify Payout New Mapping',
            breadCrumb: 'Shopify Payouts'
        })
        .state('user.organization.settingView.mapping.shopify-mapping', {
            url: '/shopify',
            templateUrl: 'settings_ui/mapping/shopify/shopify-mapping.html',
            controller: 'ShopifyMappingCtrl as shopifymapping',
            params: {
                orgId: null
            },
            title: 'Shopify Payout New Mapping',
            breadCrumb: 'Shopify Payouts'
        })

    .state('user.organization.settingView.mapping.payout-mapping-list', {
        url: '/amazon-payout-list?pageNumber&size&name&sortBy',
        templateUrl: 'settings_ui/mapping/amazon_payouts/payout-mapping.html',
        controller: 'PayoutMappingListCtrl as payoutList',
        params: {
            orgId: null
        },
        title: 'Amazon Payout Mapping',
        breadCrumb: 'Amazon Payout'
    })

    .state('user.organization.settingView.mapping.payoutNewMapping', {
        url: '/amazon-payout-new?id',
        templateUrl: 'settings_ui/mapping/amazon_payouts/payout-mapping-new.html',
        controller: 'PayoutMappingListCtrl as payoutList',
        params: {
            orgId: null,
            mapping: null
        },
        title: 'Amazon Payout Mapping',
        breadCrumb: 'Amazon Payout'
    })

    .state('user.organization.settingView.mapping.payout-mapping', {
            url: '/amazon-payout/:mappingId/accounts?pageNumber&size&name&accountName&accountCode&sortBy',
            templateUrl: 'settings_ui/mapping/amazon_payouts/payout-mapping-details.html',
            controller: 'PayoutMappingCtrl as payoutmapping',
            params: {
                orgId: null
            },
            title: 'Amazon Payout Mapping',
            breadCrumb: 'Amazon Payout'
        })
        .state('user.organization.settingView.productListing', {
            url: '/product-listing?pageNumber&size&sku&fnsku&fromdate&todate&sortBy',
            controller: 'ProductCtrl as product',
            templateUrl: 'settings_ui/product_cost/product-listing.html',
            title: 'Product Cost',
            breadCrumb: 'Product Cost',
            params: {
                orgId: null
            }
        })
        .state('user.organization.settingView.productNew', {
            url: '/amazon-product-cost?id',
            controller: 'ProductCtrl as product',
            templateUrl: 'settings_ui/product_cost/product-new.html',
            title: 'Add New Product',
            breadCrumb: 'Product Cost',
            params: {
                orgId: null
            }
        })
        .state('user.organization.settingView.pendingJobs', {
            url: '/pending-jobs?page&size',
            controller: 'PendingJobsCtrl as pendingJobs',
            templateUrl: 'settings_ui/pending-jobs.html',
            title: 'Pending Jobs',
            breadCrumb: 'Pending Jobs',
            params: {
                orgId: null
            }
        })
        .state('user.organization.settingView.autoInvoicing', {
            url: '/auto-invoice',
            controller: 'AutoInvoiceCtrl as autoInvoice',
            templateUrl: 'settings_ui/auto-invoice.html',
            title: 'Auto Invoicing',
            breadCrumb: 'Auto Invoicing',
            params: {
                orgId: null
            }
        })
        .state('user.organization.settingView.reviewRules', {
            url: '/review-rules',
            templateUrl: 'admin/review-rules.html',
            controller: 'ReviewRulesCtrl as reviewRules',
            breadCrumb: 'Review Rules'
        })
        .state('user.organization.settingView.checklistTasks', {
            url: '/checklists',
            template: '<div ui-view></div>',
            breadCrumb: 'Tasks',
            abstract: true,
            redirectTo: 'user.organization.settingView.checklistTasks.default'
        })
        .state('user.organization.settingView.checklistTasks.default', {
            url: '?task_status',
            templateUrl: 'settings_ui/checklist/checklist-tasks.html',
            controller: 'ChecklistTasksCtrl as checklistTasks',
        })
        .state('user.organization.settingView.checklistTasks.taskNew', {
            url: '/tasks/list{checklistId}/task{taskId}',
            templateUrl: 'settings_ui/checklist/task-new.html',
            controller: 'ChecklistTasksCtrl as checklistTasks',
            breadCrumb: 'Add or Edit Task',
        })
        .state('user.organization.settingView.checklistTasks.standaloneTask', {
            url: '/tasks?taskId',
            templateUrl: 'settings_ui/checklist/task-new.html',
            controller: 'ChecklistTasksCtrl as checklistTasks',
            breadCrumb: 'Add or Edit Task',
            redirectTo: 'user.organization.settingView.checklistTasks',
        })
        .state('user.organization.settingView.payoutHistory', {
            url: '/amazon-payout-history?pageNumber&size&sortBy',
            templateUrl: 'settings_ui/payout-history.html',
            controller: 'AmazonPayoutHistoryCtrl as payoutHistory',
            breadCrumb: 'Amazon Payout History',
            params: {
                orgId: null
            }
        })
        .state('user.organizations', {
            url: '/organizations',
            templateUrl: 'admin/organization-view.html',
            abstract: true,
            resolve: {
                auth: function($auth, $state) {
                    $auth.validateUser()
                        .then(function() {
                            if ($auth.user.role == 'admin' || $auth.user.role == 'accountant') {
                                return true;
                            } else {
                                return $state.go('login', { inherit: false });
                            }
                        })
                        .catch(function() {
                            return $state.go('login', { inherit: false });
                        });
                }
            },
            breadCrumb: 'Admin / Organization',
            redirectTo: 'user.organizations.list'
        })
        .state('user.organizations.default', {
            url: '',
            controller: 'OrganizationCtrl as organization',
            templateUrl: 'admin/organizations.html',
            title: 'Organizations'
        })
        .state('user.organizations.list', {
            url: '/organizations-list?pageNumber&size&name&sortBy',
            controller: 'OrganizationCtrl as organization',
            templateUrl: 'admin/organizations.html',
            title: 'Organizations'
        })
        .state('user.organizations.userList', {
            url: '/organization{orgId}/users-list?pageNumber&size&name&email&company&sortBy',
            templateUrl: 'admin/organization-userList.html',
            controller: 'OrganizationUsersCtrl as orgUsers',
            breadCrumb: 'Users',
        })
        .state('user.profile', {
            url: '/profile',
            templateUrl: 'settings_ui/profile/profile.html',
            title: 'Profile',
            controller: 'ProfileCtrl as profile',
            breadCrumb: 'Profile'
        })
        .state('user.profile-edit', {
            url: '/profile/edit',
            templateUrl: 'settings_ui/profile/profile-edit.html',
            title: 'Profile Edit',
            controller: 'ProfileCtrl as profile',
            breadCrumb: 'Edit Profile'
        })
        .state('forgotPassword', {
            url: '/forgot-password',
            controller: 'PasswordCtrl as password',
            templateUrl: 'forgot-password.html',
            title: 'Forget Password'
        })
        .state('resetPassword', {
            url: '/reset-password?client_id&token_hash&uid',
            templateUrl: 'reset-password.html',
            controller: 'PasswordCtrl as password',
            title: 'Reset Password'
        })
        .state('acceptInvitation', {
            url: '/accept-invitation?invitation_token',
            controller: 'InvitationCtrl as invitation',
            templateUrl: 'accept_invitation.html'
        })
        //Start of client routing
        .state('client', {
            url: '',
            controller: 'ClientCtrl as client',
            templateUrl: 'client/header.html',
            abstract: true,
            resolve: {
                auth: function($auth, $state, $rootScope, toaster,CommonService, $stateParams, UserService) {
                    $auth.validateUser()
                        .then(function() {
                            if ($auth.user) {
                                if($auth.user.role == 'client'){
                                    UserService.organizations($stateParams.orgId, function(data) {
                                        if (data && data.data && data.data.organizations.length > 0) {
                                            var index = (data.data.organizations.map(function(d) {
                                                return d.organization.id;
                                            })).indexOf(parseInt($stateParams.orgId));
                                            if (index == -1 && !data.data.default_organization) {
                                                $rootScope.currentOrg = data.data.organizations[0].organization.id;
                                                $rootScope.currentOrgObj = data.data.default_organization ? data.data.default_organization : data.data.organizations.find(d => d.organization.id == $rootScope.currentOrg).organization;
                                                return $state.go($state.current.name, { orgId: data.data.organizations[0].organization.id }, { inherit: false });
                                            } else {
                                                $rootScope.userOrganizations = UserService.getOrganizationArray(data.data);
                                                $rootScope.currentOrg = $stateParams.orgId;
                                                $rootScope.currentOrgObj = data.data.default_organization ? data.data.default_organization : data.data.organizations.find(d => d.organization.id == $rootScope.currentOrg).organization;
                                            }
                                            return true;
                                        } else if (data && data.data && data.data.errors && data.data.errors.length > 0) {
                                            toaster.pop('error', CommonService.throwError(data));
                                            return $state.go('client.clientDashboard.connection', { inherit: false });
                                        } else {
                                            toaster.pop('info', 'You do not have any organizations. Please connect to Xero and select organization.');
                                            return $state.go('client.clientDashboard.connection', { inherit: false });
                                        }
                                    });
                                }else{
                                    return $state.go('user.mainDashboard', { inherit: false});
                                }
                            }
                        })
                        .catch(function() {
                            return $state.go('login', { inherit: false });
                        });
                }
            }
        })
        .state('client.notification', {
          url: '/notifications?pageNumber&size',
          controller: 'NotificationCtrl as notification',
          templateUrl: 'layouts/notification.html',
          title: 'Notification',
          breadCrumb: 'Notification'
      })
        .state('client.connectionView',{
            url: '',
            templateUrl: 'client/connection-view.html',            
            title: 'Connection',
            breadCrumb: 'Connections'
        })
        .state('client.connectionView.connection',{
            url: '/connections',
            controller: 'ConnectionCtrl as connection',
            templateUrl: 'settings_ui/connections/connections.html',
            title: 'Connection',
        })
        .state('client.connectionView.amazon-conn', {
            url: '/amazon-connection/:editId',
            controller: 'ConnectionCtrl as connection',
            templateUrl: 'settings_ui/connections/amazon-connection.html',
            title: 'Amazon Connection',
            breadCrumb: 'Amazon Connection'
        })
        .state('client.connectionView.oauth-callback', {
            url: '/oauth_callback',
            controller: 'ConnectionCtrl as connection',
            templateUrl: 'settings_ui/connections/connections.html'
        })
        .state('client.clientDashboard', {
            url: '/organization{orgId}',
            templateUrl: 'client/client-dashboard.html',
            abstract: true,
            controller: function($rootScope){
                $rootScope.organizationNameView = true;
            },
            redirectTo: 'client.clientDashboard.tasks'
        })
        .state('client.clientDashboard.default', {
            url: '/',
            templateUrl: 'settings_ui/checklist/checklist-tasks.html',
            controller: 'ChecklistTasksCtrl as checklistTasks',
            title: 'Tasks',
            breadCumb: 'Tasks',
        })
        .state('client.clientDashboard.tasks', {
            url: '/tasks?task_status',
            templateUrl: 'settings_ui/checklist/checklist-tasks.html',
            controller: 'ChecklistTasksCtrl as checklistTasks',
            title: 'Tasks',
            breadCrumb: 'Tasks'
        })
        .state('client.clientDashboard.productListing', {
            url: '/organization{orgId}/product-listing?pageNumber&size&sku&fnsku&fromdate&todate&sortBy',
            controller: 'ProductCtrl as product',
            templateUrl: 'client/product-cost.html',
            title: 'Product Cost',
            breadCrumb: 'Product Cost',
            params: {
                orgId: null
            }
        })
        .state('client.clientDashboard.productNew', {
            url: '/organization{orgId}/amazon-product-cost?id',
            controller: 'ProductCtrl as product',
            templateUrl: 'client/product-new.html',
            title: 'Add New Product',
            breadCrumb: 'Product Cost',
            params: {
                orgId: null
            }
        });
    $urlRouterProvider.otherwise('/organization/bulk');
}

export default OnConfig;